<template>
  <div class="music-form">
      <h3>{{ title }}</h3>
      <hr>
      <AppTextField
            v-model="form.title"
            :error="errors.title"
      >
          Title
      </AppTextField>

      <div class="input-wrapper">
        <AppTextField
            v-model="form.artist"
            :error="errors.artist"
        >
            Artist
        </AppTextField>
          <AppDropdown
            v-model="form.theme"
            :options="themeItems"
            :error="errors.theme"
        >
            Theme
        </AppDropdown>
      </div>

        <div class="input-wrapper--inverse">
            <span>Classification</span>
            <div class="input-wrapper">
                <AppTextField
                    v-model="form.classification.alpha"
                    :error="errors.classification.alpha"
                    placeholder="Alpha (%)"
                />
                <AppTextField
                    v-model="form.classification.beta"
                    :error="errors.classification.beta"
                    placeholder="Beta (%)"
                />
                <AppTextField
                    v-model="form.classification.delta"
                    :error="errors.classification.delta"
                    placeholder="Delta (%)"
                />
            </div>
      </div>

      <MusicPlayer
        v-model="form.music"
        :error="errors.music"
    />

      <div class="actions">
          <AppButton modifier="small-danger" @click="$emit('cancel')">
                Cancel
            </AppButton>
            <AppButton modifier="small-primary" @click="handleSubmit">
                Add
            </AppButton>
      </div>
  </div>
</template>

<script>
import AppDropdown from '@/components/AppDropdown'
import AppButton from '@/components/AppButton'
import AppTextField from '@/components/AppTextField'
import MusicPlayer from '@/components/MusicPlayer'
import song from '@/store/song/app.js'
import { errorMessage } from '@/utils/helpers'
import { rawMusicErrors } from '@/utils/meta'
import { mapFields } from 'vuex-map-fields'

export default {
	props: {
		title: {
			type: String,
			default: 'Upload New Music'
		}
	},
	data () {
		return {
			themeItems: ['Gaming', 'Travelling'],
			classificationItems: [
				'Alpha',
				'Beta',
				'Delta'
			]
		}
	},
	methods: {
		handleSubmit () {
			this.errors = { ...rawMusicErrors }
			for (const key in this.form) {
				const value = this.form[key]
				if (value === null || (typeof value === 'string' && !value.trim().length)) {
					this.errors[key] = errorMessage.required(key)
				}
			}
			Object.keys(this.errors).every(key => !this.errors[key]) && this.$emit('submit')
		}
	},
	computed: {
		...mapFields('song', ['form', 'errors'])
	},
	beforeCreate () {
		if (!this.$store.hasModule('song')) {
			this.$store.registerModule('song', song)
		}
	},
	components: {
		AppDropdown,
		AppButton,
		AppTextField,
		MusicPlayer
	}
}
</script>

<style lang="scss" scoped>

.music-form {
    display: flex;
    flex-direction: column;
}

/deep/ .app-text-field {
    margin-bottom: 22px;
    color: darken($danger, 30%);

    &:first-of-type {
        margin-top: 22px;
    }
}

.input-wrapper {
    display: flex;
    .app-dropdown {
        width: 100%;
    }

    .app-text-field {
        width: 100%;
        margin: 0 12px 0 0;
    }

    &--inverse {
        display: flex;
        flex-direction: column;
        margin-top: 22px;

        span {
            margin-bottom: 6px;
        }
    }
}

.music-player {
    margin: 22px 0 100px 0;
}

.actions {
    display: flex;
    justify-content: space-between;

    .app-button {
        width: 80px;
        padding: 8px 0;
    }
}

</style>
